export enum IOrdersGroupType {
  Month = 'month',
  Category = 'category',
}
